import LocalFireDepartmentOutlinedIcon from '@mui/icons-material/LocalFireDepartmentOutlined';
import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined';
import AcUnitRoundedIcon from '@mui/icons-material/AcUnitRounded';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import EventBusyOutlinedIcon from '@mui/icons-material/EventBusyOutlined';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import LeadsConfig from '../../../consts/LeadsConfig';

const hoursSince = (createdAt) => Math.floor((new Date() - new Date(createdAt)) / (1000 * 60 * 60));

/**
 * Temperatura pelo tempo desde a chegada (mesma regra de antes: até 24 h
 * quente, até 72 h morno, depois frio). `tone` é a cor do card.
 */
export const leadTemperature = (createdAt) => {
  const hours = hoursSince(createdAt);
  if (hours <= 24) return { tone: 'hot', label: 'Quente', hint: 'Chegou há menos de 24 horas', Icon: LocalFireDepartmentOutlinedIcon };
  if (hours <= 72) return { tone: 'warm', label: 'Morno', hint: 'Chegou entre 1 e 3 dias atrás', Icon: WbSunnyOutlinedIcon };
  return { tone: 'cold', label: 'Frio', hint: 'Chegou há mais de 3 dias', Icon: AcUnitRoundedIcon };
};

/**
 * Resultado de um lead finalizado; null quando ainda pendente.
 * Lead convertido em paciente sem agendamento (`hasAppointment` vem do
 * get_leads.php) é "Virou paciente" (`converted`); "Agendado" só com agendamento.
 */
export const leadResult = (result, { patientId = null, hasAppointment = false } = {}) => {
  if (result == LeadsConfig.ResultSuccess && patientId && !hasAppointment) {
    return { tone: 'success', label: 'Virou paciente', converted: true, Icon: HowToRegOutlinedIcon };
  }
  if (result == LeadsConfig.ResultSuccess) return { tone: 'success', label: 'Agendado', Icon: EventAvailableOutlinedIcon };
  if (result == LeadsConfig.ResultFailure) return { tone: 'failure', label: 'Não agendado', Icon: EventBusyOutlinedIcon };
  if (result == LeadsConfig.ResultFailureInactive) return { tone: 'failureInactive', label: 'Não agendado', hint: 'Encerrado por inatividade', Icon: EventBusyOutlinedIcon };
  return null;
};

/**
 * "agora", "há 2 min", "há 3 h", "ontem", "há 4 dias": leitura rápida;
 * a data e a hora exatas ficam no tooltip (fullDate).
 */
export const relativeTime = (createdAt) => {
  const date = new Date(createdAt);
  if (Number.isNaN(date.getTime())) return '';
  const minutes = Math.floor((new Date() - date) / (1000 * 60));
  if (minutes < 1) return 'agora';
  if (minutes < 60) return `há ${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `há ${hours} h`;
  // Dias de calendário: chegou ontem à noite é "ontem", mesmo com menos de 48 h
  const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const days = Math.round((startOfDay(new Date()) - startOfDay(date)) / (1000 * 60 * 60 * 24));
  if (days <= 1) return 'ontem';
  if (days < 30) return `há ${days} dias`;
  const months = Math.floor(days / 30);
  return months === 1 ? 'há 1 mês' : `há ${months} meses`;
};

/** "14/10/2026 às 09:32" */
export const fullDate = (createdAt) => {
  const date = new Date(createdAt);
  if (Number.isNaN(date.getTime())) return '';
  const day = date.toLocaleDateString('pt-BR');
  const time = date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  return `${day} às ${time}`;
};

export const initialsOf = (name) => {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '';
  const first = parts[0].charAt(0);
  const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
  return (first + last).toUpperCase();
};
